/**
 * IncidentsShell — sub-tab nav for the three incident tables.
 *
 * Each child route mounts a separate filterable table component.
 */

import { NavLink, Outlet } from 'react-router';

export function IncidentsShell(): JSX.Element {
  return (
    <>
      <h1>Incidents</h1>
      <p className="page-intro">
        Pipeline-error carts, failed notification dispatches, and stuck
        signature requests. Each table is filterable and exportable to CSV.
      </p>

      <nav className="subnav" aria-label="Incident sub-pages" data-tour="incidents-subnav">
        <NavLink to="pipeline-errors">Pipeline errors</NavLink>
        <NavLink to="notification-failures">Notification failures</NavLink>
        <NavLink to="awaiting-signatures-stuck">Awaiting-signature stuck</NavLink>
      </nav>

      <Outlet />
    </>
  );
}
